module.exports = __webpack_public_path__ + "img/P45-en.7075850c.png";